module.exports = __webpack_public_path__ + "img/sleeve_cap_rise.6a5210aa.png";